import { PropsWithChildren } from 'react';

export const UnorderedList = ({ children }: PropsWithChildren) => {
  return (
    <ul className="mb-4 list-disc pl-8" data-testid="ul-markup">
      {children}
    </ul>
  );
};
